import React from "react";
import PdfBase from "../../Others/Pdf/PdfBase";
import { generateCaSchedulePdf, generateS19SchedulePdf } from "./generator";
import ExcelBase from "../../Others/Excel/ExcelBase";

const PdfGenerator = ({
  schedule,
  company,
  caType,
  refSources,
  additionsDetails,
  disposalDetails,
  hirePurchaseAdditions,
  hirePurchaseDisposal,
  totalAdditionsDetails,
  totalDisposalDetails,
  totalHpAdditionsDetails,
  totalHpDisposalDetails,
  totalNetAA,
  caSummaryDetails,
  notes,
  reviewNotes,
}) => {
  const sharedArgs = [
    schedule,
    company,
    caType,
    refSources,
    additionsDetails,
    disposalDetails,
    hirePurchaseAdditions,
    hirePurchaseDisposal,
    totalAdditionsDetails,
    totalDisposalDetails,
    totalHpAdditionsDetails,
    totalHpDisposalDetails,
    totalNetAA,
    caSummaryDetails,
    notes,
    reviewNotes,
  ];
  return (
    <>
      <PdfBase
        company={company}
        generatePdf={(forView) =>
          caType === "S19"
            ? generateS19SchedulePdf(forView, ...sharedArgs)
            : generateCaSchedulePdf(forView, ...sharedArgs)
        }
        downloadName={`${caType} Capital Allowance Schedule`}
        enableDraftView
      />
      <ExcelBase
        generateExcel={(forView) =>
          caType === "S19"
            ? generateS19SchedulePdf(forView, ...sharedArgs, true)
            : generateCaSchedulePdf(forView, ...sharedArgs, true)
        }
      />
    </>
  );
};

export default PdfGenerator;
